import { render, staticRenderFns } from "./SecureHome.vue?vue&type=template&id=206e7504"
import script from "./SecureHome.vue?vue&type=script&lang=js"
export * from "./SecureHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206e7504')) {
      api.createRecord('206e7504', component.options)
    } else {
      api.reload('206e7504', component.options)
    }
    module.hot.accept("./SecureHome.vue?vue&type=template&id=206e7504", function () {
      api.rerender('206e7504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/secure/SecureHome.vue"
export default component.exports